import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true,
};

const pre = 'setting-';

export default {
    path: '/setting',
    name: 'setting',
    redirect: {
        name: `${pre}account`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'self',
            name: `${pre}self`,
            meta: {
                ...meta,
                title: '个人中心'
            },
            component: () => import('@/pages/setting/account')
        }
    ]
};
